import { render } from "./ApiKeyIntegrationSettingsController.vue?vue&type=template&id=70687725&scoped=true"
import script from "./ApiKeyIntegrationSettingsController.vue?vue&type=script&lang=js"
export * from "./ApiKeyIntegrationSettingsController.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70687725"]])

export default __exports__